import React, { Component } from 'react'
import Footer from '../components/Footer/Footer.jsx'
class ebookLayout extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { data } = this.props
    return (
      <div>
        <div className="ebook-wrapper">{this.props.children()}</div>
        <Footer info={data} />
      </div>
    )
  }
}

export default ebookLayout

export const query = graphql`
  query FooterQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/ebookLayout.jsx